import { useContext } from 'react'
import {
  Home,
  Car,
  PieChart,
  Settings,
  Fuel,
  Wrench,
  Phone,
} from 'lucide-react'

import { RoutesPath } from 'src/types'
import { useLocales } from 'src/contexts'

import { useNavigation } from 'src/hooks/useNavigation'
import { AnalyticsContext } from 'src/contexts/AnalyticsContext'

import { ChildrenProps } from 'src/features/AppSidebar/types'
import { useSidebar } from 'src/components/shadcn/sidebar'

export const useAppSidebar = () => {
  const { navigateTo, activeRoute } = useNavigation()
  const { translations } = useLocales()
  const { logEvent } = useContext(AnalyticsContext)
  const { isMobile, setOpenMobile } = useSidebar()

  const handleOpenRoute = (route: RoutesPath): void => {
    navigateTo(route)

    if (isMobile) setOpenMobile(false)
  }

  const listOfRoutes = [
    {
      title: translations.layout.home,
      icon: Home,
      onClick: (): void => handleOpenRoute(RoutesPath.HOME),
      isActive: activeRoute === RoutesPath.HOME,
      children: [],
    },
    {
      title: translations.layout.myCars,
      icon: Car,
      onClick: (): void => handleOpenRoute(RoutesPath.MY_CARS),
      isActive: activeRoute === RoutesPath.MY_CARS,
      children: [],
    },
    /*    {
      title: translations.layout.calendar,
      icon: Calendar,
      onClick: (): void => handleOpenRoute(RoutesPath.CALENDAR),
      isActive: activeRoute === RoutesPath.CALENDAR,
      children: [],
    },*/
    {
      title: translations.layout.fuelTrack.title,
      icon: Fuel,
      children: [
        {
          title: translations.layout.fuelTrack.fuel,
          onClick: (): void => handleOpenRoute(RoutesPath.FUEL_TRACKING),
          isActive: activeRoute === RoutesPath.FUEL_TRACKING,
        },
        {
          title: translations.layout.fuelTrack.history,
          onClick: (): void => handleOpenRoute(RoutesPath.FUEL_HISTORY),
          isActive: activeRoute === RoutesPath.FUEL_HISTORY,
        },
      ],
    },
    {
      title: translations.layout.serviceMaintenance.title,
      icon: Wrench,
      children: [
        {
          title: translations.layout.serviceMaintenance.service,
          onClick: (): void => handleOpenRoute(RoutesPath.SERVICE_MAINTENANCE),
          isActive: activeRoute === RoutesPath.SERVICE_MAINTENANCE,
        },
        {
          title: translations.layout.serviceMaintenance.history,
          onClick: (): void =>
            handleOpenRoute(RoutesPath.SERVICE_MAINTENANCE_HISTORY),
          isActive: activeRoute === RoutesPath.SERVICE_MAINTENANCE_HISTORY,
        },
      ],
    },
    {
      title: translations.layout.serviceContacts.title,
      icon: Phone,
      children: [
        {
          title: translations.layout.serviceContacts.contacts,
          onClick: (): void => handleOpenRoute(RoutesPath.SERVICE_CONTACTS),
          isActive: activeRoute === RoutesPath.SERVICE_CONTACTS,
        },
        {
          title: translations.layout.serviceContacts.history,
          onClick: (): void =>
            handleOpenRoute(RoutesPath.SERVICE_CONTACTS_HISTORY),
          isActive: activeRoute === RoutesPath.SERVICE_CONTACTS_HISTORY,
        },
      ],
    },
    {
      title: translations.layout.analytics,
      icon: PieChart,
      onClick: (): void => handleOpenRoute(RoutesPath.ANALYTICS),
      isActive: activeRoute === RoutesPath.ANALYTICS,
      children: [],
    },
  ]

  const getIsRouteActive = (arr: Array<ChildrenProps>): boolean => {
    return arr.some(item => item.isActive)
  }

  const goToHome = (): void => {
    navigateTo(RoutesPath.HOME)
  }

  const settings = {
    title: translations.layout.setting,
    icon: Settings,
    onClick: (): void => handleOpenRoute(RoutesPath.SETTING),
    isActive: activeRoute === RoutesPath.SETTING,
    children: [],
  }

  return {
    listOfRoutes,
    getIsRouteActive,
    goToHome,
    settings,
    logEvent,
    isMobile,
  }
}
